<template>
  <div class="ccs-layout">
    <div class="ccs-layout ccs-12 ccs-layout--no-pad">
      <ccs-input class="ccs-4" v-bind:value="event.notifications_policies.manual"
        v-bind="fieldsDefinitions.manual" :items="notificationPolicies"
        :modifiers="['no_cancel']" :readOnly="!permissionsStatus.isEventUpdateAllowed"
        @select="(policy) => this.submit('manual', policy)"/>
      <ccs-input class="ccs-4" v-bind:value="event.notifications_policies.control_point_request_created"
        v-bind="fieldsDefinitions.control_point_request_created" :items="notificationPolicies"
        :modifiers="['no_cancel']" :readOnly="!permissionsStatus.isEventUpdateAllowed"
        @select="(policy) => this.submit('control_point_request_created', policy)"/>
      <ccs-input class="ccs-4" v-bind:value="event.notifications_policies.control_point_request_resolved"
        v-bind="fieldsDefinitions.control_point_request_resolved" :items="notificationPolicies"
        :modifiers="['no_cancel']" :readOnly="!permissionsStatus.isEventUpdateAllowed"
        @select="(policy) => this.submit('control_point_request_resolved', policy)"/>
      <ccs-input class="ccs-4" v-bind:value="event.notifications_policies.critical_control_point_closure_requested"
        v-bind="fieldsDefinitions.critical_control_point_closure_requested" :items="notificationPolicies"
        :modifiers="['no_cancel']" :readOnly="!permissionsStatus.isEventUpdateAllowed"
        @select="(policy) => this.submit('critical_control_point_closure_requested', policy)"/>
      <ccs-input class="ccs-4" v-bind:value="event.notifications_policies.critical_control_point_closure_resolved"
        v-bind="fieldsDefinitions.critical_control_point_closure_resolved" :items="notificationPolicies"
        :modifiers="['no_cancel']" :readOnly="!permissionsStatus.isEventUpdateAllowed"
        @select="(policy) => this.submit('critical_control_point_closure_resolved', policy)"/>
      <ccs-input class="ccs-4" v-bind:value="event.notifications_policies.project_completed"
        v-bind="fieldsDefinitions.project_completed" :items="notificationPolicies"
        :modifiers="['no_cancel']" :readOnly="!permissionsStatus.isEventUpdateAllowed"
        @select="(policy) => this.submit('project_completed', policy)"/>
      <ccs-input class="ccs-4" v-bind:value="event.notifications_policies.control_point_deadline_approaching"
        v-bind="fieldsDefinitions.control_point_deadline_approaching" :items="notificationPolicies"
        :modifiers="['no_cancel']" :readOnly="!permissionsStatus.isEventUpdateAllowed"
        @select="(policy) => this.submit('control_point_deadline_approaching', policy)"/>
    </div>
    <div class="ccs-layout ccs-layout--no-pad">
      <div>
        <button class="ccs-button" @click="$emit('close')">
          Закрыть
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

import Input from '@/components/forms/Input.vue';

export default {
  name: 'NotificationsPolicies',
  components: {
    'ccs-input': Input,
  },
  data() {
    return {
      notificationPolicies: [{
          prop: 'do_not_send',
          text: 'Не отправлять',
        }, {
          prop: 'system_only',
          text: 'Только системные',
        }, {
          prop: 'email_only',
          text: 'Только email',
        }, {
          prop: 'all',
          text: 'Все',
        },
      ],
      fieldsDefinitions: {
        manual: {
          isValid: true,
          error: '',
          required: false,
          type: "dropdown",
          label: "Ручные уведомления",
          placeholder: "Выберите политику",
        },
        control_point_request_created: {
          isValid: true,
          error: '',
          required: false,
          type: "dropdown",
          label: "Запрос на изменение КТ",
          placeholder: "Выберите политику",
        },
        control_point_request_resolved: {
          isValid: true,
          error: '',
          required: false,
          type: "dropdown",
          label: "Решение по запросу на изменение КТ",
          placeholder: "Выберите политику",
        },
        critical_control_point_closure_requested: {
          isValid: true,
          error: '',
          required: false,
          type: "dropdown",
          label: "Запрос на закрытие ККТ",
          placeholder: "Выберите политику",
        },
        critical_control_point_closure_resolved: {
          isValid: true,
          error: '',
          required: false,
          type: "dropdown",
          label: "Решение по запросу на закрытие ККТ",
          placeholder: "Выберите политику",
        },
        project_completed: {
          isValid: true,
          error: '',
          required: false,
          type: "dropdown",
          label: "Проект выполнен на 100%",
          placeholder: "Выберите политику",
        },
        control_point_deadline_approaching: {
          isValid: true,
          error: '',
          required: false,
          type: "dropdown",
          label: "У КТ истекает срок исполнения",
          placeholder: "Выберите политику",
        },
      },
    }
  },
  computed: {
    ...mapState('events', ['event']),
    ...mapGetters('session', ['permissionsStatus']),
  },
  methods: {
    ...mapActions('events', ['setNotificationPolicy', 'updateParticipant']),
    async submit(type, policy) {
      try {
        await this.setNotificationPolicy({ type, policy });
        this.$toasted.success('Политика уведомления успешно обновлена');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
  },
}
</script>

<style>

</style>